var React = require('react');

function PatternTriangle (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Triangle"),React.createElement("path",{"d":"M271 0v276H0","key":1})]);
}

PatternTriangle.defaultProps = {"width":"271","height":"276","viewBox":"0 0 271 276"};

module.exports = PatternTriangle;

PatternTriangle.default = PatternTriangle;
